import React from "react";
import { Tooltip, Breadcrumbs, Typography } from "@material-ui/core";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SettingsIcon from "@mui/icons-material/Settings";
import { ASSETS } from "../../../utils/config";
import { colors } from "../../../utils";
import TextView from "../../TextView";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

const FoldersHeader = ({
  title,
  showArrowIcon,
  onArrowClick,
  showCreateFolderIcon,
  onCreateFolderIconPress,
  folderPath,
  onBreadcrumbClick,
  onSettingsClick,
}) => {
  const breadcrumbStyle = {
    fontSize: 20,
    color: colors.darkGrey,
    fontFamily: "DM Sans, sans-serif",
    fontWeight: 400,
    cursor: "pointer",
  };

  console.log({ folderPath });

  const getCurrentFolder = () => {
    return folderPath[folderPath.length - 1];
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
        {showArrowIcon && (
          <ArrowBackIcon
            sx={{ cursor: "pointer", fontSize: 25 }}
            onClick={onArrowClick}
          />
        )}
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="folder navigation"
        >
          <div onClick={() => onBreadcrumbClick(null)}>
            {folderPath.length === 0 ? (
              <TextView variant="title">My Folders</TextView>
            ) : (
              <Typography style={breadcrumbStyle}>My Folders</Typography>
            )}
          </div>
          {folderPath.map((folder, index) => {
            const isLast = index === folderPath.length - 1;
            return isLast ? (
              <div
                key={folder.id}
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <TextView variant="title">{folder.name}</TextView>
                {showCreateFolderIcon && (
                  <Tooltip title="Folder Settings">
                    <SettingsIcon
                      sx={{
                        cursor: "pointer",
                        fontSize: 20,
                        color: colors.darkGrey,
                        "&:hover": {
                          color: colors.PrimaryPurple,
                        },
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        onSettingsClick(getCurrentFolder());
                      }}
                    />
                  </Tooltip>
                )}
              </div>
            ) : (
              <div key={folder.id} onClick={() => onBreadcrumbClick(folder)}>
                <Typography style={breadcrumbStyle}>{folder.name}</Typography>
              </div>
            );
          })}
        </Breadcrumbs>
      </div>
      {showCreateFolderIcon && (
        <Tooltip title="Create Folder">
          <div
            style={{
              width: 40,
              height: 40,
              borderRadius: 4,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: colors.PrimaryPurple400,
              cursor: "pointer",
            }}
            onClick={onCreateFolderIconPress}
          >
            <img
              src={ASSETS.segmentEditor.AddFolder}
              width={24}
              height={24}
              alt="Add Folder"
            />
          </div>
        </Tooltip>
      )}
    </div>
  );
};

export default FoldersHeader;
